import api from './api';

class RoleService {
    // Get all roles
    static async getAll(page = 1, limit = 100) {
        try {
            const response = await api.get(`/roles?page=${page}&limit=${limit}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get role by ID
    static async getById(id) {
        try {
            const response = await api.get(`/roles/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create new role
    static async create(data) {
        try {
            const response = await api.post('/roles', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update role
    static async update(id, data) {
        try {
            const response = await api.put(`/roles/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update role status
    static async updateStatus(id, status) {
        try {
            const response = await api.patch(`/roles/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default RoleService;